import type { PromotedTarget } from './benefitEstimate';
import type { T } from '../../../lib/i18n-core';
import { won } from '../price';
import { targetLine } from './benefitEstimate';
import { badgeClass, typeLabel } from '../labels';

/**
 * 함께 담으면 혜택을 받는 상품 — **구매 박스의 세 번째 묶음**이다(2026-08-24 사용자 제안).
 *
 * 처음에는 따로 선 카드로 냈는데, 사용자가 더 나은 구조를 제안했다 —
 * `강좌 / 교재 / 함께 담으면 혜택을 받습니다` 를 한 칸에 나란히 두고 오른쪽에 총 결제금액.
 * 담을 것이 한 자리에 모이고, 굴러가는 총액이 바로 옆이라 눈에 들어온다.
 *
 * 교재 상세(`BdTop`)에는 그런 묶음 칸이 없어 `variant="card"` 로 따로 선 카드를 쓴다.
 */
export function BenefitPicks({ picks, checked, onToggle, priceDetail, t, variant = 'group' }: {
  picks: PromotedTarget[];
  checked: Set<number>;
  onToggle: (id: number) => void;
  priceDetail: boolean;
  t: T;
  variant?: 'group' | 'card';
}) {
  if (!picks.length) return null;

  const rows = picks.map((tg) => {
    // 혜택이 걸린 채널의 단가로 보여 준다 — 담길 때도 그 단가로 담긴다
    const line = targetLine(tg, priceDetail, tg.wantPlatform);
    return (
      <div className="pd-buy-row" key={tg.id}>
        {/* 체크 모양은 강좌·교재 줄과 같은 것을 쓴다(가이드 `custom-check`) */}
        <label className="custom-check">
          <input type="checkbox" checked={checked.has(tg.id)} onChange={() => onToggle(tg.id)} />
          <span className="check-box"></span>
          {/* 종류(단과·패키지·프리패스·교재) — 무엇을 더 담는지 알아야 고를 수 있다.
              배지는 목록 카드와 같은 것을 쓴다(같은 뜻에 같은 모양) */}
          <span className={`badge-type ${badgeClass(tg.type)} filter`}>{typeLabel(tg.type, t)}</span>
          <span className="item-name">{tg.name}</span>
        </label>
        <div className="pd-buy-price">
          {line.price <= 0 ? t('prd.free') : `${won(line.price)}${t('prd.money')}`}
        </div>
      </div>
    );
  });

  if (variant === 'card') {
    return (
      <section className="pd-benefit pd-benefit-add">
        <p className="pd-benefit-head">{t('prd.benefit.addMore')}</p>
        {rows}
      </section>
    );
  }
  return (
    <>
      <div className="pd-buy-divider"></div>
      {/* 이 묶음만 색을 준다 — 사야 할 것이 아니라 **더 담으면 좋은 것**이다 */}
      <div className="pd-buy-group-lbl is-benefit">{t('prd.benefit.addMore')}</div>
      {rows}
    </>
  );
}
